export enum FORM_FIELDS {
    EMAIL = 'email',
}

export type FormFieldsType = {
    [FORM_FIELDS.EMAIL]: string;
}
